import { service } from '@ember/service';
import Component from '@glimmer/component';
import { objectAppend } from 'scaleflow/utils/obj-append';

export default class ThemesTableIndexComponent extends Component {
  @service intl;

  get columns() {
    if (this.args?.columns) return this.args?.columns;
    return [
      {
        name: this.intl.t('themes.table.title'),
        valuePath: 'title',
        class: '!w-[80%] !top-0',
        key: 'title',
        component: 'themes/table-cell/title',
      },
      {
        name: '',
        valuePath: 'edit',
        class: '!w-[10%] !top-0',
        key: 'edit',
        component: 'link',
        type: 'primary',
        test_id: 'edit-theme',
      },
      {
        name: '',
        valuePath: 'delete',
        class: '!w-[10%] !top-0',
        key: 'delete',
        component: 'button',
        type: 'danger',
        test_id: 'delete',
      },
    ];
  }

  get rows() {
    if (this.args?.rows) return this.args?.rows;
    const onDelete = this.args?.onThemeDelete ?? function () {};

    const themes = this.args?.themes.map((item) =>
      objectAppend(
        {
          title: { label: item.title },
          edit: {
            label: this.intl.t('themes.table.edit'),
            route: 'settings.tags.edit',
            model: item,
          },
          delete: {
            label: this.intl.t('themes.table.delete'),
            onClick: () => onDelete(item),
          },
        },
        { model: item },
      ),
    );
    return themes;
  }
}
